import React, {CSSProperties} from 'react'

type DisplayProps = {
  className?: string
  children?: React.ReactNode
  onClick?: () => void
  style?: CSSProperties
}

export function Col(props: DisplayProps) {
  return (
    <div onClick={props.onClick} style={props.style} className={`flex flex-col ${props.className ?? ''}`}>
      {props.children}
    </div>
  )
}

export function Row(props: DisplayProps) {
  return (
    <div onClick={props.onClick} style={props.style} className={`flex flex-row ${props.className ?? ''}`}>
      {props.children}
    </div>
  )
}

export function Box(props: DisplayProps) {
  return (
    <div onClick={props.onClick} style={props.style} className={`flex box ${props.className ?? ''}`}>
      {props.children}
    </div>
  )
}
